/**
 * Labstep
 *
 * @module models/organization-plan-price
 * @desc Typescript export class for OrganizationPlanPrice
 */

import type { Organization } from 'labstep-web/models/organization.model';
import type { CurrencyISO } from 'labstep-web/services/currency.service';

export class OrganizationPlanPrice {
  static readonly entityName = 'organization_plan_price' as const;

  get entityName(): string {
    return OrganizationPlanPrice.entityName;
  }

  constructor(data: Partial<OrganizationPlanPrice>) {
    Object.assign(this, data);
  }

  id!: string;

  _tier!: Organization['tier'];

  currency!: CurrencyISO;

  unit_amount!: number | null;

  interval!: 'day' | 'week' | 'month' | 'year';

  get tier(): Organization['tier'] {
    return this._tier || 'basic';
  }

  set tier(tier: Organization['tier']) {
    this._tier = tier;
  }
}
